// frontend/src/pages/CookiePolicyPage.jsx
// Cookie Policy - Redirects to Termly for auto-updated policy

import React, { useEffect } from 'react';
import { ArrowLeft, Cookie, ExternalLink } from 'lucide-react';

const CookiePolicyPage = () => {
  const termlyUrl = "https://app.termly.io/policy-viewer/policy.html?policyUUID=100465bb-3d3b-411f-aff7-5d646e607eb6";

  // Auto-redirect after 3 seconds (optional - remove if you want manual click only)
  useEffect(() => {
    const timer = setTimeout(() => {
      window.open(termlyUrl, '_blank');
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button onClick={() => window.history.back()} className="flex items-center text-gray-600 hover:text-gray-900">
              <ArrowLeft size={20} className="mr-2" />
              <span>Back</span>
            </button>
            <div className="flex items-center">
              <Cookie size={20} className="text-blue-600 mr-2" />
              <span className="font-semibold text-gray-900">UniLedge</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-10 text-center">
          
          {/* Icon */}
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Cookie size={32} className="text-blue-600" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
          
          <p className="text-gray-600 mb-6">
            Our Cookie Policy explains how UniLedge uses cookies and similar tracking technologies 
            to provide, improve, and protect our services.
          </p>

          <p className="text-gray-500 mb-8">
            You will be redirected to our full Cookie Policy automatically...
          </p>

          {/* Manual Link */}
          <a 
            href={termlyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            View Cookie Policy
            <ExternalLink size={18} className="ml-2" />
          </a>

          {/* Consent Preferences */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-3">
              Want to update your cookie preferences?
            </p>
            <a 
              href="#" 
              className="termly-display-preferences text-blue-600 hover:underline font-medium"
              onClick={(e) => e.preventDefault()}
            >
              Manage Cookie Preferences
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;